export const dolog = () =>{
    return {
        type: 'SIGN_IN'
    }
}

export const toggleMenu = () =>{
    return {
        type: 'MENU_VISIBLE'
    }
}